"use client";
import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { PolymorphicContext } from "./PolymorphicContext.js";
const PolymorphicProvider = ({ components, children }) => {
  const values = useMemo(() => ({ components }), []);
  return /* @__PURE__ */ jsx(PolymorphicContext.Provider, { value: values, children });
};
export {
  PolymorphicProvider
};
